import { JetView } from 'webix-jet'; // Importing JetView from webix-jet for creating views
import PlayersView from 'views/players'; // Importing PlayersView component
import FilterReport from 'views/reports/betsReport/filterReport'; // Importing FilterReport component
import TableReport from 'views/reports/betsReport/tableReport'; // Importing TableReport component
import TableTransactionsReport from 'views/reports/betsReport/recordTransReport'; // Importing TableTransactionsReport component
import RecordReport from 'views/reports/betsReport/recordReport'; // Importing RecordReport component
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * BetsReportView class extends JetView to create a report view for bets.
 */
export default class BetsReportView extends JetView {
    /**
     * Configures the layout of the BetsReportView.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const theme = this.app.config.theme; // Theme configuration
        const vthis = this; // Reference to the current instance

        // Right section layout with players and reports
        const right = {
            type: 'wide',
            rows: [PlayersView, RecordReport, TableTransactionsReport],
        };

        // Alternative right section layout for smaller screens
        const right2 = {
            height: 1,
            id: 'right2',
            width: screen.width - 54,
            type: 'wide',
            rows: [RecordReport, TableTransactionsReport],
        };

        // Toolbar configuration for pagination and export options
        const toolbar = {
            view: 'toolbar',
            css: 'highlighted_header header6',
            id: 'toolbar',
            paddingX: 5,
            paddingY: 5,
            height: 40,
            cols: [
                {
                    view: 'select', // Dropdown for selecting number of items per page
                    options: ['10', '20', '50', '100', '1000'],
                    width: 70,
                    on: {
                        onChange: function () {
                            $$('datatable').getPager().config.size = this.getValue() * 1; // Update pager size
                            $$('datatable').refresh(); // Refresh the datatable
                            $$('datatable').scrollTo(100, 0); // Scroll to the top
                        },
                    },
                },
                {
                    view: 'pager', // Pager for navigating through pages
                    id: 'pagerA',
                    template:
                        '{common.first()}{common.prev()}&nbsp; {common.pages()}&nbsp; {common.next()}{common.last()}',
                    autosize: false,
                    height: 35,
                    size: devConfig.getDefaultDataFetch(), // Default fetch size from config
                },
                {
                    view: 'richselect', // Dropdown for export options
                    name: 'Export',
                    id: 'Export',
                    width: 120,
                    placeholder: _('Exportar'), // Placeholder for export dropdown
                    options: [
                        { id: '1', value: 'Excel' }, // Excel export option
                        { id: '2', value: 'PDF' }, // PDF export option
                    ],
                    on: {
                        onChange: function (value) {
                            var table = $$('datatable'); // Reference to the datatable
                            var size = $$('datatable').getPager().config.size; // Current page size
                            var page = $$('datatable').getPage(); // Current page number
                            var first = size * page; // Calculate first item index
                            var last = first + size - 1; // Calculate last item index
                            if (value !== '') {
                                vthis.app.callEvent('export:filter', [
                                    { value: value, first: first, last: last }, // Trigger export event
                                ]);
                            }
                        },
                    },
                },
            ],
        };

        // Second toolbar for export options
        const toolbar2 = {
            view: 'toolbar',
            id: 'toolbar2',
            css: 'highlighted_header header6',
            paddingX: 5,
            paddingY: 5,
            height: 40,
            cols: [
                {},
                {
                    view: 'richselect', // Dropdown for export options
                    name: 'Export',
                    id: 'Export2',
                    width: 120,
                    placeholder: _('Exportar'), // Placeholder for export dropdown
                    options: [
                        { id: '1', value: 'Excel' }, // Excel export option
                        { id: '2', value: 'PDF' }, // PDF export option
                    ],
                    on: {
                        onChange: function (value) {
                            if (value == 1) {
                                // If Excel is selected
                                var table = $$('datatable2'); // Reference to the second datatable
                                for (var j = 0; j < table.config.columns.length; j++) {
                                    if (table.config.columns[j].exportType) {
                                        delete table.config.columns[j].format; // Remove format for export
                                    }
                                }
                                webix.toExcel(table, {
                                    // Export to Excel
                                    filename:
                                        'Virtualsoft - ' +
                                        new Date()
                                            .toLocaleString('en-GB', {
                                                hour12: true,
                                            })
                                            .replace(/^(\d{4})-(\d{2})-(\d{2})$/g, '$3/$2/$1')
                                            .replace(/[\/:]/g, '_')
                                            .toUpperCase() +
                                        ' - ' +
                                        ($$('datatable2').count() > 0 ? '' : _('No hay datos - ')) +
                                        'Apuestas', // Filename with date and data status
                                    ignore: { detailTittle: true }, // Ignore detail title in export
                                    footer: false, // Do not include footer
                                });
                            } else {
                                if (value == 2) {
                                    // If PDF is selected
                                    webix.toPDF($$('datatable2'), {
                                        // Export to PDF
                                        filename:
                                            'Virtualsoft - ' +
                                            new Date()
                                                .toLocaleString('en-GB', {
                                                    hour12: true,
                                                })
                                                .replace(/^(\d{4})-(\d{2})-(\d{2})$/g, '$3/$2/$1')
                                                .replace(/[\/:]/g, '_')
                                                .toUpperCase() +
                                            ' - ' +
                                            ($$('datatable2').count() > 0 ? '' : _('No hay datos - ')) +
                                            'Apuestas', // Filename with date and data status
                                        autowidth: true, // Auto width for PDF
                                        ignore: { detailTittle: true }, // Ignore detail title in export
                                        footer: false, // Do not include footer
                                    });
                                }
                            }
                            $$('Export2').setValue(''); // Reset export selection
                        },
                    },
                },
            ],
        };

        // Left section layout with filters and reports
        const left = {
            css: 'int-left',
            rows: [
                {
                    view: 'toolbar', // Toolbar for report title and search button
                    css: theme,
                    elements: [
                        { view: 'label', label: _('Reporte de Apuestas') }, // Report title
                        {
                            type: 'wide',
                            css: 'close-bottom',
                            id: 'button-search', // Search button
                            cols: [
                                {
                                    view: 'icon',
                                    icon: 'wxi-search', // Search icon
                                    bottom: 20,
                                    right: 35,
                                    width: 30,
                                    height: 30,
                                    click: () => {
                                        $$('filterPopup').show(); // Show filter popup on click
                                    },
                                },
                            ],
                        },
                    ],
                },
                FilterReport, // Filter report component
                { id: 'res2', view: 'resizer' }, // Resizer for layout
                TableReport, // Table report component
                toolbar, // First toolbar
                toolbar2, // Second toolbar
            ],
        };

        // Advanced details section with accordion layout
        const avanc = {
            view: 'accordion',
            multi: true,
            collapsed: true,
            cols: [
                { id: 'dColl', header: _('Detalles Avanzados'), body: right }, // Advanced details header and body
            ],
        };

        // Responsive advanced details section
        const avancResp = {
            view: 'accordion',
            multi: true,
            collapsed: true,
            rows: [
                {
                    id: 'dColl',
                    header: _('Detalles Avanzados'), // Advanced details header
                    body: right, // Body with right section
                    minWidth: 250,
                    on: {
                        onItemClick: function () {
                            var height;
                            $(function () {
                                height =
                                    $('.scrolling > .webix_scroll_cont').height() -
                                    $('.webix_view.webix_form.scrolling.webix_layout_clean').height(); // Calculate height for scrolling
                                if (!$$('dColl').config.collapsed) {
                                    $('.scrolling > .webix_scroll_cont').css({
                                        transform: 'translate3d(0px, -' + height + 'px, 0px)', // Adjust scroll position
                                    });
                                } else {
                                    $$('a5').scrollTo(100, 0); // Scroll to top if collapsed
                                    height =
                                        $('.scrolling > .webix_scroll_cont').height() -
                                        $('.webix_view.webix_form.scrolling.webix_layout_clean').height(); // Recalculate height
                                    $('.scrolling > .webix_scroll_cont').css({
                                        transform: 'translate3d(0px, -' + height + 'px, 0px)', // Adjust scroll position
                                    });
                                }
                            });
                        },
                    },
                },
            ],
        };

        webix.ui.fullScreen(); // Set the UI to full screen mode

        // Return the main layout configuration
        return {
            id: 'a5',
            type: 'clean',
            view: 'form',
            scroll: 'y', // Enable vertical scrolling
            css: 'scrolling',
            rows: [
                {
                    responsive: 'a5',
                    type: 'wide',
                    cols: [
                        left, // Left section with filters and reports
                        { id: 'res', view: 'resizer' }, // Resizer for layout
                        screen.width < 500 || screen.height < 500
                            ? right2 // Use right2 layout for small screens
                            : avanc, // Use advanced layout for larger screens
                    ],
                },
            ],
        };
    }

    /**
     * Initializes the BetsReportView.
     * @param {Object} grid - The grid object to initialize.
     */
    init(grid) {
        webix.ready(function () {
            if (screen.width < 500 || screen.height < 500) {
                $$('res').hide(); // Hide resizer for small screens
                $$('res2').hide(); // Hide second resizer for small screens
                var childs = $$('toolbar').getChildViews(); // Get child views of the toolbar
                $$('toolbar').removeView(childs[2]); // Remove the third child (export dropdown)
                $$('pagerA').define('group', 1); // Define pager group for small screens
            }
            if (screen.width > 500 && screen.height > 500) {
                $$('button-search').hide(); // Hide search button for larger screens
            }
            $.fn.scrollBottom = function () {
                return $(document).height() - this.scrollTop() - this.height(); // Calculate scroll bottom position
            };
        });
    }
}

// FILE DOCUMENTED
